import login from '@/login'
import { isPortalEnabled, redirectToPortalLogin } from '@/auth-portal'
import routes from '@/router/routes'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history',

})

router.beforeEach((to, from, next) => {
  // let app = this.app
  // if (this.a) {
  //   app = this.a.app
  // }
  // app.$Progress.start()
  if (to.meta.requiresAuth && !login.is()) {
    if (isPortalEnabled()) {
      redirectToPortalLogin(to.fullPath)
      return next(false)
    }
    return next({name: 'login'})
  }

  return next()
})

// router.afterEach((to, from, next) => {
  // let app = this.app
  // if (this.a) {
  //   app = this.a.app
  // }

  // app.$Progress.finish()
// })

export default router
